const marketCodes = {
    PMI: 'PMI',
    CZ: 'CZ',
};

export default marketCodes;
